export default {
  documentUpload: {
    '& > div': {
      borderStyle: 'none !important',
      height: 'auto !important',
    },
  },
};
